export default function NivaLogo({ variant = 'default', className = '', centered = false }) {
  const isHeader = variant === 'header';

  if (isHeader) {
    return (
      <div className={`flex items-center gap-2 overflow-visible ${centered ? 'justify-center' : ''} ${className}`}>
        <img src="/sawtna_final_blue.svg" alt="Sawtna" className="h-8 w-auto overflow-visible" />
      </div>
    );
  }

  return (
    <div className={`flex flex-col items-center overflow-visible ${className}`}>
      <img src="/sawtna_final_blue.svg" alt="Sawtna" className="h-14 w-auto max-w-[280px] overflow-visible" />
    </div>
  );
}
